import { useState, useRef } from 'react'

import { Center, Spinner, Text } from '@chakra-ui/react'

import Modal from '../../modal'
import { useRanContext } from '../../ran-state-provider'

import { userMaintenance } from '../../../lib/api-helper'

import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from '../../../lib/api-config'

const ForgotCharPin = ({ onClose, setToast }) => {
  const { setAuthentication } = useRanContext()
  const [isLoading, setLoading] = useState(false)
  const recaptchaRef = useRef(null);

  const handleSubmit = async () => {
    if (isLoading) return
    setLoading(true)

    const captchaToken = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();

    const payload = {
        captchaToken
    };

    const result = await userMaintenance(
      'FORGOT_CHARPIN',
      payload,
      setAuthentication
    )

    const onError = () => {
      setToast({
        status: 'error',
        messages: result?.errors?.length
          ? result.errors
          : ['Something went wrong']
      })
      setLoading(false)
    }

    if (result !== null || result !== undefined) {
      if (result.success) {
        setToast({
          status: 'success',
          messages: ['CHAR PIN has been sent to your registered email address']
        })
        onClose()
      } else onError()
    } else onError()
  }

  return (
    <>
    <Modal
      header="FORGOT CHAR PIN"
      isOpen={true}
      isLoading={isLoading}
      onClose={onClose}
      onSubmit={handleSubmit}
      SubmitText="RECOVER"
    >
      {isLoading ? (
        <Center>
          <Spinner />
        </Center>
      ) : (
        <Text align="center">
          Press SUBMIT button to receive your CHAR PIN in your registered email
          address
        </Text>
      )}
    </Modal>
    <ReCAPTCHA
            sitekey={RECAPTCHA_SITE_KEY}
            size="invisible"
            ref={recaptchaRef}
        />
    </>
  )
}

export default ForgotCharPin
